import { InjectionToken, Injectable, Inject, Optional, ɵɵdefineInjectable, ɵɵinject, Directive, ViewContainerRef, TemplateRef, ComponentFactoryResolver, ChangeDetectorRef, Input, ANALYZE_FOR_ENTRY_COMPONENTS, SkipSelf, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const LAZY_ELEMENT_CONFIGS = new InjectionToken('LAZY_ELEMENT_CONFIGS');
/** @type {?} */
const LAZY_ELEMENT_ROOT_OPTIONS = new InjectionToken('LAZY_ELEMENT_ROOT_OPTIONS');
/** @type {?} */
const LAZY_ELEMENT_ROOT_GUARD = new InjectionToken('LAZY_ELEMENT_ROOT_GUARD');
/** @type {?} */
const LAZY_ELEMENTS_REGISTRY = new InjectionToken('Lazu elements registry', {
    providedIn: 'root',
    factory: (/**
     * @return {?}
     */
    () => new Map())
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const LOG_PREFIX = '@angular-extensions/elements';
class LazyElementsLoaderService {
    /**
     * @param {?} registry
     * @param {?} options
     */
    constructor(registry, options) {
        this.registry = registry;
        this.options = options;
        this.configs = [];
        if (!options) {
            this.options = {};
        }
    }
    /**
     * @param {?} newConfigs
     * @return {?}
     */
    addConfigs(newConfigs) {
        newConfigs.forEach((/**
         * @param {?} newConfig
         * @return {?}
         */
        newConfig => {
            /** @type {?} */
            const existingConfig = this.getElementConfig(newConfig.tag);
            if (existingConfig) {
                console.warn(`${LOG_PREFIX} - ElementConfig for tag '${newConfig.tag}' was previously added, it will not be added multiple times, continue...`);
            }
            else {
                this.configs.push(newConfig);
                /** @type {?} */
                const shouldPreload = newConfig.preload !== undefined
                    ? newConfig.preload
                    : this.options.preload;
                if (shouldPreload) {
                    this.loadElement(newConfig.url, newConfig.tag, newConfig.isModule);
                }
            }
        }));
    }
    /**
     * @param {?} tag
     * @return {?}
     */
    getElementConfig(tag) {
        return this.configs.find((/**
         * @param {?} config
         * @return {?}
         */
        config => config.tag === tag));
    }
    /**
     * @param {?=} tags
     * @return {?}
     */
    preload(tags) {
        /** @type {?} */
        let configs = this.configs;
        if (tags) {
            configs = this.configs.filter((/**
             * @param {?} config
             * @return {?}
             */
            config => tags.includes(config.tag)));
        }
        configs.forEach((/**
         * @param {?} config
         * @return {?}
         */
        config => this.loadElement(config.url, config.tag, config.isModule)));
    }
    /**
     * @param {?} url
     * @param {?} tag
     * @param {?=} isModule
     * @return {?}
     */
    loadElement(url, tag, isModule) {
        /** @type {?} */
        const config = this.getElementConfig(tag);
        if (!url) {
            if (!config || !config.url) {
                throw new Error(`${LOG_PREFIX} - url for <${tag}> not found`);
            }
            url = config.url;
        }
        if (isModule === undefined) {
            isModule =
                config && config.isModule !== undefined
                    ? config.isModule
                    : this.options.isModule;
        }
        if (!tag) {
            throw new Error(`${LOG_PREFIX} - tag for '${url}' not found, the *axLazyElement has to be used on HTML element`);
        }
        if (!this.hasElement(url)) {
            /** @type {?} */
            const notifier = this.addElement(url);
            /** @type {?} */
            const script = (/** @type {?} */ (document.createElement('script')));
            if (isModule) {
                script.type = 'module';
            }
            script.src = url;
            script.onload = notifier.resolve;
            script.onerror = notifier.reject;
            document.body.appendChild(script);
        }
        return this.registry.get(this.stripUrlProtocol(url));
    }
    /**
     * @private
     * @param {?} url
     * @return {?}
     */
    addElement(url) {
        /** @type {?} */
        let notifier;
        this.registry.set(this.stripUrlProtocol(url), new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        (resolve, reject) => (notifier = { resolve, reject }))));
        return notifier;
    }
    /**
     * @private
     * @param {?} url
     * @return {?}
     */
    hasElement(url) {
        return this.registry.has(this.stripUrlProtocol(url));
    }
    /**
     * @private
     * @param {?} url
     * @return {?}
     */
    stripUrlProtocol(url) {
        return url.replace(/https?:\/\//, '');
    }
}
LazyElementsLoaderService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
LazyElementsLoaderService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [LAZY_ELEMENTS_REGISTRY,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [LAZY_ELEMENT_ROOT_OPTIONS,] }] }
];
/** @nocollapse */ LazyElementsLoaderService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LazyElementsLoaderService_Factory() { return new LazyElementsLoaderService(ɵɵinject(LAZY_ELEMENTS_REGISTRY), ɵɵinject(LAZY_ELEMENT_ROOT_OPTIONS, 8)); }, token: LazyElementsLoaderService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const LOG_PREFIX$1 = '@angular-extensions/elements';
class LazyElementDirective {
    // tslint:disable-line:no-input-rename
    /**
     * @param {?} vcr
     * @param {?} template
     * @param {?} elementsLoaderService
     * @param {?} cfr
     * @param {?} cdr
     */
    constructor(vcr, template, elementsLoaderService, cfr, cdr) {
        this.vcr = vcr;
        this.template = template;
        this.elementsLoaderService = elementsLoaderService;
        this.cfr = cfr;
        this.cdr = cdr;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const tpl = (/** @type {?} */ (this.template));
        /** @type {?} */
        const elementTag = tpl._declarationTContainer
            ? tpl._declarationTContainer.tagName
            : tpl._def.element.template.nodes[0].element.name;
        /** @type {?} */
        const elementConfig = this.elementsLoaderService.getElementConfig(elementTag) ||
            ((/** @type {?} */ ({})));
        /** @type {?} */
        const options = this.elementsLoaderService.options;
        /** @type {?} */
        const loadingComponent = elementConfig.loadingComponent || options.loadingComponent;
        if (this.loadingTemplateRef) {
            this.vcr.createEmbeddedView(this.loadingTemplateRef);
        }
        else if (loadingComponent) {
            /** @type {?} */
            const factory = this.cfr.resolveComponentFactory(loadingComponent);
            this.vcr.createComponent(factory);
        }
        this.elementsLoaderService
            .loadElement(this.url, elementTag, this.isModule)
            .then((/**
         * @return {?}
         */
        () => {
            this.vcr.clear();
            this.vcr.createEmbeddedView(this.template);
            this.cdr.markForCheck();
        }))
            .catch((/**
         * @return {?}
         */
        () => {
            this.vcr.clear();
            /** @type {?} */
            const errorComponent = elementConfig.errorComponent || options.errorComponent;
            if (this.errorTemplateRef) {
                this.vcr.createEmbeddedView(this.errorTemplateRef);
                this.cdr.markForCheck();
            }
            else if (errorComponent) {
                /** @type {?} */
                const factory = this.cfr.resolveComponentFactory(errorComponent);
                this.vcr.createComponent(factory);
                this.cdr.markForCheck();
            }
            else {
                console.error(`${LOG_PREFIX$1} - Loading of element <${elementTag}> failed, please provide <ng-template #error>Loading failed...</ng-template> and reference it in *axLazyElement="errorTemplate: error" to display customized error message in place of element`);
            }
        }));
    }
}
LazyElementDirective.decorators = [
    { type: Directive, args: [{
                selector: '[axLazyElement]'
            },] }
];
/** @nocollapse */
LazyElementDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TemplateRef },
    { type: LazyElementsLoaderService },
    { type: ComponentFactoryResolver },
    { type: ChangeDetectorRef }
];
LazyElementDirective.propDecorators = {
    url: [{ type: Input, args: ['axLazyElement',] }],
    loadingTemplateRef: [{ type: Input, args: ['axLazyElementLoadingTemplate',] }],
    errorTemplateRef: [{ type: Input, args: ['axLazyElementErrorTemplate',] }],
    isModule: [{ type: Input, args: ['axLazyElementModule',] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const LOG_PREFIX$2 = '@angular-extensions/elements';
class LazyElementDynamicDirective {
    // tslint:disable-line:no-input-rename
    /**
     * @param {?} vcr
     * @param {?} template
     * @param {?} elementsLoaderService
     * @param {?} cfr
     * @param {?} cdr
     */
    constructor(vcr, template, elementsLoaderService, cfr, cdr) {
        this.vcr = vcr;
        this.template = template;
        this.elementsLoaderService = elementsLoaderService;
        this.cfr = cfr;
        this.cdr = cdr;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (!this.tag || this.tag.length === 0 || !this.tag.includes('-')) {
            throw new Error(`${LOG_PREFIX$2} - Valid tag has to be specified when using *axLazyElementDynamic directive (use *axLazyElementDynamic="'some-tag'"), got: "${this.tag}"`);
        }
        /** @type {?} */
        const elementConfig = this.elementsLoaderService.getElementConfig(this.tag) ||
            ((/** @type {?} */ ({})));
        /** @type {?} */
        const options = this.elementsLoaderService.options;
        /** @type {?} */
        const loadingComponent = elementConfig.loadingComponent || options.loadingComponent;
        if (this.loadingTemplateRef) {
            this.vcr.createEmbeddedView(this.loadingTemplateRef);
        }
        else if (loadingComponent) {
            /** @type {?} */
            const factory = this.cfr.resolveComponentFactory(loadingComponent);
            this.vcr.createComponent(factory);
        }
        this.elementsLoaderService
            .loadElement(this.url, this.tag, this.isModule)
            .then((/**
         * @return {?}
         */
        () => {
            if (((/** @type {?} */ (this.template)))._declarationTContainer) {
                // (this.template as any)._declarationTContainer.tagName = this.tag;
                throw new Error('The *axLazyElementDynamic directive is currently does NOT support Angular Ivy, please use standard *axLazyElement directive instead!');
            }
            else {
                ((/** @type {?} */ (this
                    .template)))._def.element.template.nodes[0].element.name = this.tag;
            }
            this.vcr.clear();
            this.vcr.createEmbeddedView(this.template);
            this.cdr.markForCheck();
        }))
            .catch((/**
         * @param {?} error
         * @return {?}
         */
        error => {
            /** @type {?} */
            const errorComponent = elementConfig.errorComponent || options.errorComponent;
            this.vcr.clear();
            if (this.errorTemplateRef) {
                this.vcr.createEmbeddedView(this.errorTemplateRef);
                this.cdr.markForCheck();
            }
            else if (errorComponent) {
                /** @type {?} */
                const factory = this.cfr.resolveComponentFactory(errorComponent);
                this.vcr.createComponent(factory);
                this.cdr.markForCheck();
            }
            else {
                console.error(`${LOG_PREFIX$2} - Loading of element <${this.tag}> failed, please provide <ng-template #error>Loading failed...</ng-template> and reference it in *axLazyElementDynamic="errorTemplate: error" to display customized error message in place of element\n\n`, error);
            }
        }));
    }
}
LazyElementDynamicDirective.decorators = [
    { type: Directive, args: [{
                selector: '[axLazyElementDynamic]'
            },] }
];
/** @nocollapse */
LazyElementDynamicDirective.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: TemplateRef },
    { type: LazyElementsLoaderService },
    { type: ComponentFactoryResolver },
    { type: ChangeDetectorRef }
];
LazyElementDynamicDirective.propDecorators = {
    tag: [{ type: Input, args: ['axLazyElementDynamic',] }],
    url: [{ type: Input, args: ['axLazyElementDynamicUrl',] }],
    loadingTemplateRef: [{ type: Input, args: ['axLazyElementDynamicLoadingTemplate',] }],
    errorTemplateRef: [{ type: Input, args: ['axLazyElementDynamicErrorTemplate',] }],
    isModule: [{ type: Input, args: ['axLazyElementDynamicModule',] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} options
 * @return {?}
 */
function createLazyElementRootGuard(options) {
    if (options) {
        throw new TypeError(`LazyElementsModule.forRoot() called twice. Feature modules should use LazyElementsModule.forFeature() instead.`);
    }
    return 'guarded';
}
class LazyElementsModule {
    /**
     * @param {?} lazyElementsLoaderService
     * @param {?} elementConfigsMultiProvider
     * @param {?} guard
     */
    constructor(lazyElementsLoaderService, elementConfigsMultiProvider, guard) {
        if (elementConfigsMultiProvider && elementConfigsMultiProvider.length) {
            /** @type {?} */
            const lastAddedConfigs = elementConfigsMultiProvider[elementConfigsMultiProvider.length - 1];
            lazyElementsLoaderService.addConfigs(lastAddedConfigs);
        }
    }
    /**
     * @param {?} options
     * @return {?}
     */
    static forRoot(options) {
        return {
            ngModule: LazyElementsModule,
            providers: [
                {
                    provide: LAZY_ELEMENT_CONFIGS,
                    useValue: options && options.elementConfigs ? options.elementConfigs : [],
                    multi: true
                },
                {
                    provide: LAZY_ELEMENT_ROOT_OPTIONS,
                    useValue: options.rootOptions ? options.rootOptions : {}
                },
                {
                    provide: ANALYZE_FOR_ENTRY_COMPONENTS,
                    useValue: options,
                    multi: true
                },
                {
                    provide: LAZY_ELEMENT_ROOT_GUARD,
                    useFactory: createLazyElementRootGuard,
                    deps: [[LAZY_ELEMENT_CONFIGS, new Optional(), new SkipSelf()]]
                }
            ]
        };
    }
    /**
     * @param {?} options
     * @return {?}
     */
    static forFeature(options) {
        return {
            ngModule: LazyElementsModule,
            providers: [
                {
                    provide: LAZY_ELEMENT_CONFIGS,
                    useValue: options && options.elementConfigs ? options.elementConfigs : [],
                    multi: true
                },
                {
                    provide: ANALYZE_FOR_ENTRY_COMPONENTS,
                    useValue: options && options.elementConfigs,
                    multi: true
                }
            ]
        };
    }
}
LazyElementsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [LazyElementDirective, LazyElementDynamicDirective],
                imports: [CommonModule],
                exports: [LazyElementDirective, LazyElementDynamicDirective],
                providers: []
            },] }
];
/** @nocollapse */
LazyElementsModule.ctorParameters = () => [
    { type: LazyElementsLoaderService },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [LAZY_ELEMENT_CONFIGS,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [LAZY_ELEMENT_ROOT_GUARD,] }] }
];

export { LAZY_ELEMENTS_REGISTRY, LazyElementsModule, createLazyElementRootGuard, LAZY_ELEMENT_CONFIGS as ɵa, LAZY_ELEMENT_ROOT_OPTIONS as ɵb, LAZY_ELEMENT_ROOT_GUARD as ɵc, LazyElementDirective as ɵd, LazyElementsLoaderService as ɵf, LazyElementDynamicDirective as ɵg };
//# sourceMappingURL=angular-extensions-elements.js.map
